<template>
  <v-app class="no-border">
    <v-main>
      <v-container fill-height>
        <v-layout
          row
          wrap
        >
          <v-flex xs12> </v-flex>
          <v-flex
            xs12
            class="text-xs-center"
            justify="center"
          >
            <a
              class="mt-5"
              :href="appUrl"
              target="_blank"
            >
              <img
                alt="app-logo"
                height="64px"
                :src="appLogo"
              />
            </a>
            <h1 class="display-1 primary--text">
              {{ $t("commons.error") }}: {{ $t("views.invalid_invitation.invalid_expired") }}
            </h1>
            <br />
            <p class="headline">{{ $t("views.invalid_invitation.contact") }}</p>
            <br />
            <h3 class="title mt-3">
              {{ $t("views.invalid_invitation.if_account") }}
              <v-btn
                text
                depressed
                class="primary--text"
                href="/signin"
              >
                {{ $t("commons.click") }}
              </v-btn>
            </h3>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      appLogo: this.$appConfig.assets.img.custom.logo,
      appUrl: this.$appConfig.url
    }
  }
}
</script>
